// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PauseOutlinedSvg from "@ant-design/icons-svg/es/asn/PauseOutlined";
import AntdIcon from '../components/AntdIcon';

var PauseOutlined = function PauseOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: PauseOutlinedSvg
  }));
};

PauseOutlined.displayName = 'PauseOutlined';
export default React.forwardRef(PauseOutlined);